module.exports = __webpack_public_path__ + "static/img/解决方案-煤矿反三违-视频全证据链溯源.9890a009.png";